import { z } from 'zod';

export const ReviewRefundSummaryTaskSchema = z.object({}).optional();
